import axios from "axios";

export const fetchPlants = ({ commit }) => {
  axios.get(`../../../data/data.json`).then((response) => {
    commit("plantsList", response.data);
  });
};
